import { Reveal } from "./Reveal";
import "./SectionHeader.css";

export function SectionHeader({ eyebrow, title, description, align = "left" }) {
  return (
    <Reveal className={`section-header section-header--${align}`}>
      {eyebrow && <span className="eyebrow">{eyebrow}</span>}
      <h2 className="h2 section-header__title">{title}</h2>
      {description && <p className="lead section-header__desc">{description}</p>}
    </Reveal>
  );
}
